import './Navbar.css';

import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Pages } from '@src/Pages';
import * as machinelogic from '@vse/main';
import { VentionLogo } from '@src/assets';
import { NavbarLinkButton } from './NavbarLinkButton';
// import { RemoteSupportEntryButton } from '@ventionco/remote-support-components'; HACK PATH-FOLLOWING-VENTION-IO REMOVE REMOTE SUPPORT BUTTON
// import { remoteSupportServices } from '@src/RemoteSupportServices'; HACK PATH-FOLLOWING-VENTION-IO REMOVE REMOTE SUPPORT BUTTON
import { NavbarRefreshButton } from './NavbarRefreshButton';
import { useUnmountReactAndNavigate } from '@src/hooks';

/**
 *
 * @param {import('@src/app_router/getNavigationLinks').NavigationLink} navigationLinks
 * @return {JSX.Element}
 * @constructor
 */
export const Navbar = ({ navigationLinks }) => {
  const navigate = useUnmountReactAndNavigate();
  const location = useLocation();

  // The config checker is considered a machine config page
  let activePage = location.pathname;
  if (activePage === Pages.CONFIG_CHECKER) {
    activePage = Pages.MACHINE_CONFIG;
  }

  return (
    <div id="navbar-container">
      <div className="navbar-initial-container">
        <div className="vention-logo-container" onClick={() => navigate(Pages.MENU)}>
          <VentionLogo id="vention-logo"/>
        </div>
        {/* <RemoteSupportEntryButton
          onClick={() => navigate(Pages.REMOTE_SUPPORT)}
          isInCall={remoteSupportServices.isInCall()}
          isInWaitingRoom={remoteSupportServices.isInWaitingRoom()}
        /> HACK PATH-FOLLOWING-VENTION-IO REMOVE REMOTE SUPPORT BUTTON */}
      </div>
      <div className="navbar-items-parent">
        {navigationLinks.map(({ page, title, iconClass, isDisabled, isHidden, isRestricted, onClick }, index) => {
          const navigationHandler = createNavigationHandler(activePage, onClick, navigate);
          return <NavbarLinkButton
              key={title}
              page={page}
              title={title}
              iconClass={iconClass}
              isHidden={isHidden}
              isRestricted={isRestricted}
              isActive={page === activePage}
              isDisabled={isDisabled}
              onClick={() => navigationHandler(page)}
            />;
        })}
        <NavbarRefreshButton/>
      </div>
    </div>
  );
};

Navbar.propTypes = {
  navigationLinks: PropTypes.arrayOf(PropTypes.object),
};

/**
 * Creates an appropriate navigation handler based on some properties.
 *
 * @param {PendantPage} [activePage] The current page we're on.
 * @param {() => void} [onClick] An onClick handler that will be called if it exists.
 * @param {Navigate} navigate A function to navigate using React Router.
 * @return {import("react-router-dom").NavigateFunction} A navigation callback.
 */
function createNavigationHandler (activePage, onClick, navigate) {
  if (onClick) {
    return onClick;
  }

  if (activePage === Pages.MACHINE_CONFIG) {
    return createSaveConfigAndNavigateHandler(navigate);
  }

  return navigate;
}

/**
 * Create a navigation callback that will deploy the config before attempting to navigate if there are pending changes.
 * This is only meant for the machine config page.
 *
 * @param {Navigate} navigate
 * @return {import("react-router-dom").NavigateFunction} A navigation callback.
 */
function createSaveConfigAndNavigateHandler (navigate) {
  return function (to, navigationOptions) {
    const lConfigManager = machinelogic.getLibrary()?.getConfigManager();
    if (lConfigManager?.mDirty) {
      machinelogic.widgets_ml.showApplyConfigurationModal(
        () => {
          lConfigManager.deploy(() => navigate(to, navigationOptions));
        },
        () => {
          lConfigManager.revertChangesToLastSave();
          navigate(to, navigationOptions);
        },
      );
    }
    else {
      navigate(to, navigationOptions);
    }
  };
}
